import { DatePipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { toLocalDayKey } from '../utils/dates';

@Pipe({
  name: 'dayLabel',
  standalone: true,
  pure: true,
})
export class DayLabelPipe implements PipeTransform {
  private translate = inject(TranslateService);

  transform(dayKey: string | null | undefined): string {
    if (!dayKey) return '';

    const now = Date.now();
    const todayKey = toLocalDayKey(now);
    if (dayKey === todayKey) return this.translate.instant('general.today_l');

    const yesterdayKey = toLocalDayKey(now - 24 * 60 * 60 * 1000);
    if (dayKey === yesterdayKey) return this.translate.instant('general.yesterday_l');

    const [year, month, day] = dayKey.split('-');
    const date = new Date(Number(year), Number(month) - 1, Number(day));
    const locale = this.translate.getCurrentLang() || 'de';
    const weekday = new DatePipe(locale).transform(date, 'EEEE') || '';
    return `${weekday}, ${day}.${month}.${year}`;
  }
}
